module.exports = __webpack_public_path__ + "static/media/vip_personality_icon.eeb09fdf.svg";